export const getStatusTagColor = (status: string) => {
  switch (status) {
    case 'paid':
      return 'green'
    case 'created':
      return 'blue'
    case 'canceled':
      return 'red'
    case 'expired':
      return 'orange'
    case 'refunded':
      return 'red'
    default:
      return 'default'
  }
}
